/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useContext, useEffect } from 'react';
import { Text } from '@oneaudi/unified-web-components';
import { makeStyles } from './makeStyles';
import { AEMModelAssets, getAllPriceRowMatches } from './tracker/constants';
import { handleUrlChange } from './tracker/handleUrlChange';
import { ContentContext } from '../context/ContentContext';

export function Demo() {
  const context = useContext(ContentContext);
  const { setPersonalizedResults, setDebugTiles } = context;

  // Stop early conditions, eg: if debugPCT is not 'yes'
  // Return in node
  const cond1 = typeof window === 'undefined';
  if (cond1) {
    return null;
  }
  // Hide this component if needed when not on localhost
  const cond2 = window.location.href.includes('https://www.audiusa.com');
  // Hide this component if debugPCT is not set to 'yes'
  const cond3 = window.localStorage.getItem('debugPCT') !== 'yes';
  if (cond2 || cond3) {
    return null;
  }
  useEffect(() => {
    console.log('[PCT] Local Storage Settings:');
    console.log('[PCT] debugPCT: yes | no');
    console.log('[PCT] debugUI: yes | no');
    console.log('[PCT] debugTiles: normal | mlp | new-build | resume-build');
  }, []);
  useEffect(() => {
    const debugTiles = window.localStorage.getItem('debugTiles');
    if (debugTiles) {
      setDebugTiles(debugTiles);
    }
  }, [setDebugTiles]);

  // Should show UI?
  const cond4 = window.localStorage.getItem('debugUI') !== 'yes';
  if (cond4) {
    return null;
  }

  const allPriceRowMatches = getAllPriceRowMatches();
  const entryRow = allPriceRowMatches[0];
  const midRow = allPriceRowMatches[1];
  const premiumRow = allPriceRowMatches[2];
  const luxuryRow = allPriceRowMatches[3];
  const ultraLuxuryRow = allPriceRowMatches[4];

  const styles = makeStyles(false, true);

  const handleUpdateStatus = (url) => {
    const localStorageResp = handleUrlChange(url);
    if (localStorageResp) {
      if (typeof window !== 'undefined') {
        window.localStorage.setItem('personalizedResults', JSON.stringify(localStorageResp));
        setPersonalizedResults(localStorageResp);
      }
    }
  };

  const getButtonRow = (key, priceRange, data) => {
    return (
      <tr key={key}>
        <td style={styles.td}>
          <Text> {priceRange} </Text>
        </td>
        <td style={styles.td}>
          <div style={{ display: 'flex', columnGap: '9px' }}>
            {data.map((model) => (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '4px',
                }}
              >
                <button
                  key={`${model.name}-mlp`}
                  style={styles.buttonMlp}
                  onClick={() => handleUpdateStatus(model.mlpUrl)}
                  onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = styles.buttonMlpHover.backgroundColor;
                    e.currentTarget.style.color = styles.buttonMlpHover.color;
                  }}
                  onFocus={(e) => {
                    e.currentTarget.style.backgroundColor = styles.buttonMlpHover.backgroundColor;
                    e.currentTarget.style.color = styles.buttonMlpHover.color;
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = styles.buttonMlp.backgroundColor;
                    e.currentTarget.style.color = styles.buttonMlp.color;
                  }}
                  onBlur={(e) => {
                    e.currentTarget.style.backgroundColor = styles.buttonMlp.backgroundColor;
                    e.currentTarget.style.color = styles.buttonMlp.color;
                  }}
                  type="button"
                >
                  {AEMModelAssets[model.name]}
                  <small> (MLP)</small>
                </button>

                <button
                  key={`${model.name}-build`}
                  style={styles.buttonBuild}
                  onClick={() => {
                    console.log(model);
                    handleUpdateStatus(model.buildUrlFake);
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = styles.buttonBuildHover.backgroundColor;
                    e.currentTarget.style.color = styles.buttonBuildHover.color;
                  }}
                  onFocus={(e) => {
                    e.currentTarget.style.backgroundColor = styles.buttonBuildHover.backgroundColor;
                    e.currentTarget.style.color = styles.buttonBuildHover.color;
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = styles.buttonBuild.backgroundColor;
                    e.currentTarget.style.color = styles.buttonBuild.color;
                  }}
                  onBlur={(e) => {
                    e.currentTarget.style.backgroundColor = styles.buttonBuild.backgroundColor;
                    e.currentTarget.style.color = styles.buttonBuild.color;
                  }}
                  type="button"
                >
                  {AEMModelAssets[model.name]}
                  <small> (BUILD)</small>
                </button>
              </div>
            ))}
          </div>
        </td>
      </tr>
    );
  };

  return (
    <div style={{ ...styles.container }}>
      <Text> Personalization Engine Configurator </Text>
      <div style={styles.tableContainer}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>
                <Text>Price</Text>
              </th>
              <th style={styles.th}>
                <Text>Simulate MLP or Build page visits</Text>{' '}
              </th>
            </tr>
          </thead>
          <tbody>
            {getButtonRow('entry', 'Entry', entryRow)}
            {getButtonRow('mid', 'Mid', midRow)}
            {getButtonRow('premium', 'Premium', premiumRow)}
            {getButtonRow('luxury', 'Luxury', luxuryRow)}
            {getButtonRow('sport', 'Sport', ultraLuxuryRow)}
          </tbody>
        </table>
      </div>
      <button
        style={styles.buttonDelete}
        onClick={() => {
          localStorage.removeItem('audiModelTracker');
          localStorage.removeItem('personalizedResults');
          window.location.reload();
        }}
        type="button"
      >
        Delete localStorage
      </button>

      <div style={{ float: 'right' }}>
        <label htmlFor="tileDebug">
          <Text>Tile Content Debug</Text>
        </label>
        <select
          id="tileDebug"
          onChange={(event) => {
            setDebugTiles(event.currentTarget.value);
          }}
        >
          <option value="normal">Default</option>
          <option value="mlp">Show all MLP tiles</option>
          <option value="new-build">Show all &quot;New Build&quot; tiles</option>
          <option value="resume-build">Show all &quot;Resume Build&quot; tiles</option>
        </select>
      </div>
    </div>
  );
}
